export const ErgaenzungSV = [
  {
    'PAISY Wert': 0,
    Bezeichnung: 'keine Bedeutung',
  },
  {
    'PAISY Wert': 1,
    Bezeichnung: 'Geringverdiener Azubi',
  },
  {
    'PAISY Wert': 2,
    Bezeichnung: 'MFB Vers.GV-KN',
  },
  {
    'PAISY Wert': 3,
    Bezeichnung: 'MFB Beiträge-Bezugsgröße',
  },
  {
    'PAISY Wert': 4,
    Bezeichnung: 'Übergangsbereich',
  },
  {
    'PAISY Wert': 5,
    Bezeichnung: 'Geringv. Praktikant',
  },
  {
    'PAISY Wert': 6,
    Bezeichnung: 'ÜB AV/ekin Freibetrag VB',
  },
  {
    'PAISY Wert': 7,
    Bezeichnung: 'AG trägt SV',
  },
  {
    'PAISY Wert': 8,
    Bezeichnung: 'Gleitzone o. rV bis 06/19',
  },
  {
    'PAISY Wert': 9,
    Bezeichnung: 'Freiw. Soz. Jahr',
  },
];
